import { array, boolean, mixed, object, string } from '@calendly/form/validation'

const answerChoicesFormats = ['choices_one', 'choices_many', 'select']
const multipleChoicesFormats = ['choices_one', 'choices_many']
export const hasAnswerChoices = (format) => answerChoicesFormats.includes(format)
export const allowsOtherChoices = (format) => multipleChoicesFormats.includes(format)

export const getValidationSchema = () => object({
  inviteeQuestions: array().of(object({
    _destroy: boolean(),
    name: string().when('_destroy', {
      is: true,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.trim().required()
    }),
    answerChoices: mixed()
      .when('format', {
        is: (format) => hasAnswerChoices(format),
        then: array().of(object({ choice: string().trim().required() })).required(),
        otherwise: (schema) => schema.notRequired()
      }),
  }))
})
